﻿window.calendarstatusresolver = function () {
    var instance = {


    //     function disallowDate(date) {
    //     if (params["jsdisableddaysargs"]) {
    //         return window['calendarstatusresolver'][params["jsdisableddaysfunc"]](date, params["jsdisableddaysargs"]);
    //
    //     }
    //
    // };
        disallowDate: function(func){
            //вызов соответсвующей функции по переданной в параметр
        },   
        
        disableArray: function (date, disableddays) {
            if (disableddays[0]) {
                for (var i = 0; i < disableddays[0].length; i++) {

                    var disableDay = new Date(disableddays[0][i]);

                    if (date.getFullYear() == disableDay.getFullYear() &&
                        date.getMonth() == disableDay.getMonth() &&
                        date.getDate() == disableDay.getDate())

                        return "disabled disabledday";
                }
                return false; // enable other dates
            }
            else return false;

        },
        disablePeriods: function (date, disableddays) {
            if (disableddays[0]) {

                var startDate = new Date(disableddays[0].item1);
                var finishDate = new Date(disableddays[0].item2);

                if (startDate < date && finishDate > date)
                    return false;
                else
                    return "disabled disabledday";            
                               
            }
            else return false;
        }

    }
    return instance;
}();